module.exports = __webpack_public_path__ + "img/9_dp.63bc31cd.png";